export function getGTMPurchaseId(sku: string, accountId: string, level: string | undefined) {
    return `${accountId}_${sku}${level ? `_${level}` : ''}`;
}
